<template>
  <unicom-layout-cartao semFiltro>
    <transition name="fade-prestador" mode="out-in">
      <unicom-linha
        key="informacoes"
        v-if="!loading"
        style="min-height: 76px"
        justificarItem="between"
      >
        <unicom-coluna sm="12" style="padding-bottom: 24px">
          <div class="titulo negrito cor-fonte fonte-primaria">Prestador</div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="auto" :class="espacamentoMobile">
          <div class="segunda-cor-fonte">CPF/CNPJ</div>
          <div class="mt-3">
            {{ objetoInformacoes.documento }}
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="auto" :class="espacamentoMobile">
          <div class="segunda-cor-fonte">Nome</div>
          <div class="mt-3">
            {{ objetoInformacoes.codigoPrestador }} -
            {{ objetoInformacoes.nomePrestador }}
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="auto" :class="espacamentoMobile">
          <div class="segunda-cor-fonte">Tipo</div>
          <div class="mt-3">
            {{ objetoInformacoes.tipo }}
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="auto" :class="espacamentoMobile">
          <div class="segunda-cor-fonte">Rede</div>
          <div class="mt-3">
            {{ objetoInformacoes.rede }}
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="auto" :class="espacamentoMobile">
          <div class="segunda-cor-fonte">Unimed</div>
          <div class="mt-3">
            {{ objetoInformacoes.unimed }}
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="auto" :class="espacamentoMobile">
          <div class="segunda-cor-fonte">Status</div>
          <div
            class="mt-3"
            style="display: flex; position: relative;"
            id="status-prestador"
            v-if="objetoInformacoes.status"
          >
            <div :style="statusPrestador.estiloTexto">
              {{ statusPrestador.textoExibicao }}
            </div>
            <div v-if="statusPrestadorIcone">
              <unicom-icone
                :style="statusPrestadorIcone.style"
                :nome="statusPrestadorIcone.icone"
                :tamanho="20"
                :tooltipNome="statusPrestadorIcone.tooltip"
                localizacaoTooltip="top"
                class="tooltip-detalhe"
              />
            </div>
          </div>
          <div v-else class="mt-3">-</div>
        </unicom-coluna>
      </unicom-linha>
      <unicom-spinner
        v-else
        key="loading"
        style="min-height: 100.8px; display: flex; align-items: center"
        :tamanhoLoading="62"
        :tamanhoLinha="7"
        :velocidade="0.5"
        :marginTopTexto="30"
      />
    </transition>
  </unicom-layout-cartao>
</template>

<script>
import { enumStatusPrestador } from "../../../../shared/helpers/Enum/EnumStatusPrestador";

export default {
  props: {
    objetoInformacoes: {
      type: Object,
      default: () => {
        return {
          codigoPrestador: "",
          nomePrestador: "",
          documento: "",
          tipo: "",
          unimed: "",
          status: "",
          rede: "",
          dataProgramada: "",
          dtEnvioExclusao: "",
          nomeArquivoExclusao: ""
        };
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      statusPrestadorLocal: {}
    };
  },
  methods: {
    iniciarStatusPrestador() {
      if (!this.objetoInformacoes.status) return;

      console.log(this.objetoInformacoes.status);

      if (this.objetoInformacoes.status == "EXCLUIDO") {
        enumStatusPrestador[this.objetoInformacoes.status].icones = [
          {
            icone: "alert-triangle",
            tooltip: "",
            direcaoEsquerda: true,
            style: {
              color: "#ED1651"
            }
          }
        ];
      }

      this.statusPrestadorLocal = JSON.parse(
        JSON.stringify(enumStatusPrestador[this.objetoInformacoes.status])
      );

      if (this.statusPrestadorIcone && this.objetoInformacoes.dataProgramada) {
        this.$set(
          this.statusPrestadorLocal.icones[0],
          "tooltip",
          `Exclusão programada para ${this.objetoInformacoes.dataProgramada}`
        );
      }

      if (this.statusPrestadorIcone && this.objetoInformacoes.dtEnvioExclusao) {
        this.$set(
          this.statusPrestadorLocal.icones[0],
          "tooltip",
          // 'Exclusão enviada em: 24/02/2023 \nArquivo: blabalbal.pdf'
          "Exclusão enviada em: " +
            this.$helpers.formatadorDataSafe(
              this.objetoInformacoes.dtEnvioExclusao
            ) +
            "\nArquivo: " +
            this.objetoInformacoes.nomeArquivoExclusao
        );
      }
    }
  },
  computed: {
    /**
     * @return {{ textoExibicao: String, estiloTexto: Object, icones: Array }}
     */
    statusPrestador() {
      return this.statusPrestadorLocal;
    },
    /**
     * @return {{ icone: String, tamanho: Number, feather: Boolean, tooltip: String, direcaoEsquerda: Boolean, style: Object}}
     */
    statusPrestadorIcone() {
      if ([null, undefined].includes(this.statusPrestadorLocal.icones))
        return null;
      return this.statusPrestadorLocal.icones[0];
    },
    /**
     * Verifica se a tela está no viewport mobile e se estiver, retorna uma classe que da o espaçamento para cima
     */
    espacamentoMobile() {
      return this.$breakpoint.smAndDown ? "mt-4" : "";
    }
  },
  watch: {
    loading() {
      if (!this.loading) {
        this.iniciarStatusPrestador();
      }
    }
  }
};
</script>

<style scoped>
.fade-prestador-enter-active,
.fade-prestador-leave,
.fade-prestador-leave-to {
  transition: opacity 0.15s;
}

.fade-prestador-enter,
.fade-prestador-leave-to {
  opacity: 0;
}
::v-deep .hsy-tooltip {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
::v-deep .hsy-tooltip > .tooltip {
  white-space: break-spaces !important;
  width: 13rem;
  font-size: 0.8rem;
  text-align: start;
}
::v-deep .outlet {
  opacity: 0;
}
</style>
